import angular from 'angular';
import inputPercentage from './inputPercentage';
import './style.scss';

export default angular
  .module('components.inputPercentage', [])
  .component('inputPercentage', inputPercentage).name;
